<template>
  <div class="block-holder" :class="getResponsiveClass">
    <div class="block-feature">
      <a :href="getAppLinkByIDAndType(linkID, linkType)" class="router-link">
        <div data-test="bgImage" :style="getBackground" class="block-image lazyload" role="img" :alt="title" :title="title" />
      </a>
      <div class="block-text">
        <p class="block-text__title" v-html="title" />
        <p class="block-text__description" v-html="description" />
        <div class="read-more-button">
          <a :href="getAppLinkByIDAndType(linkID, linkType)" class="read-more router-link">
            Read more <img src="../assets/img/src/icons/arrow.svg" class="read-more-arrow lazyload" alt="Arrow" height="10px" width="36px">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReadMoreBlock',
  props: {
    imgURL: { type: String, required: true },
    linkID: { type: String },
    linkType: { type: String },
    title: { type: String, required: true },
    description: { type: String, required: true },
    responsive: { type: Boolean, default: true },
  },
  computed: {
    getResponsiveClass() {
      return {
        responsive: this.responsive,
      };
    },
    getBackground() {
      return {
        backgroundImage: `url("${encodeURI(this.imgURL)}")`,
      };
    },
  },
  methods: {

    getAppLinkByID(pageID) {
      return this.$store.getters['applinks/getLink']('page', pageID).url;
    },

    getAppLinkByIDAndType(pageID, type) {
      if (isNaN(pageID)) return pageID; // the pageId in this case is the URL (the curated list manager in the CMS can now set the URL manually as oppose just being able to select an type and ID)
      return this.$store.getters['applinks/getLink']('page', pageID).url;
    },

    gotoPage(pageID, type) {
      if (pageID) {
        parseInt(pageID) > 0 ? window.location = this.getAppLinkByIDAndType(pageID, type) : window.location = pageID;
      }
    },

    getBackgroundImage(url) {
      return {
        backgroundImage: `url(${url})`,
      };
    },
  },

};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings/_config.scss";

// Must be kept at 3:2 ratio
$image-width: 280px;
$image-height: 187px;

.lazy {
   background-image: none !important;
   background-color: $solitude;
}

.block-holder{
    @include text-primary;
    display: flex;
    justify-content:center;
    align-items: flex-start;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    border: 1px solid transparent;
}

.block-feature{
    width: $image-width;
    margin: 1em;
}

.block-text{
    margin-left: 2px;

    &__description {
        @include body-text;
        font-size: 15px;
        font-weight: 400;
    }

    &__title {
        @include text-header;
        margin-top: 20px;
        font-family: $font-family-grotesk;
        font-size: 18px;
        font-weight: 500
    }

}

.block-image-container {
    overflow: hidden;
    width: $image-width;
    height: $image-width;
}

.block-image{
    width: $image-width;
    height: $image-height;
    display: block;
    cursor: pointer;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-color: $silver;
}

.read-more-button {
    padding: 8px 0 0 0;
    border-top: 1px solid $solitude;
    width: 60%;
}

.read-more {
    font-size: 18px;
    display: inline-block;
    font-family: $font-family-editorial;
    font-weight: 300;
    color:$darkBlack;
    text-decoration: none !important;
    &:visited, &:hover {
      color: $darkBlack;

    }
}

.read-more-arrow {
   margin-left: 15px;
   cursor: pointer;
}

.responsive{
    @media (max-width: 1024px) {
    .block-holder{
        justify-content:center;
        flex-direction: column;
        flex-wrap: wrap;
        width: auto;
    }

    .block-feature{
        width: 90%;
    }

    .block-image{
        width: 100%;
    }
 }

}

</style>
